import type { Maybe, ModelType } from '@/types'
import type { MakeMaybe } from '@/types/utilities'

export interface UserListItem extends Omit<ModelType, 'sort'> {
  name: string
  email: string
  phone: Maybe<string>
  roles: UserRole[]
}

export type User = UserListItem

export type UserFormType = MakeMaybe<
  Pick<User, 'name' | 'email'>,
  'name' | 'email'
> & {
  role_name: UserRole['code']
  password: Maybe<string>
}

export interface UserRole extends Omit<ModelType, 'sort' | 'active'> {
  code: UserRoleCodes
  name: string
  description: string
}

export enum UserRoleCodes {
  Administrator = 'administrator',
  Manager = 'manager',
  Salesman = 'salesman',
  Customer = 'customer',
}
